import { render, staticRenderFns } from "./InvestmentAssetsFilters.vue?vue&type=template&id=025865a2&scoped=true&"
import script from "./InvestmentAssetsFilters.vue?vue&type=script&lang=js&"
export * from "./InvestmentAssetsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025865a2",
  null
  
)

export default component.exports